/**
 * Type-safe routing system
 *
 * @example
 * ```typescript
 * import { routes } from '@/shared/utils/routing';
 *
 * // Simple route
 * const homeUrl = routes.home.url();
 * // => '/'
 *
 * // Route with slug
 * const blogUrl = routes.blog.detail.url('my-post');
 * // => '/blog/my-post'
 *
 * // Route with query parameters
 * const searchUrl = routes.search.url({
 *   location: 'Miami',
 *   checkIn: '2024-01-01',
 *   adults: 2
 * });
 * // => '/search?location=Miami&checkIn=2024-01-01&adults=2'
 *
 * // Parse query parameters
 * const filters = routes.search.parse(searchParams);
 * // => { location: 'Miami', adults: 2 } (typed as SearchQueryParams)
 *
 * // Slug + query
 * const rentalUrl = routes.rental.detail.url('villa', {
 *   checkIn: '2024-01-01',
 *   adults: 4
 * });
 * // => '/rentals/villa?checkIn=2024-01-01&adults=4'
 *
 * // Attraction helpers
 * const isValid = routes.destinations.attraction.helpers.isValidAttractionType('things-to-do');
 * // => true
 * ```
 */

// Main routes export
export {routes, type Routes, type RentalQueryParams, TRIP_TABS, type TripTab} from "./routes.config";

// Helper exports
export {attractionHelpers, type AttractionHelpers} from "./attraction-helpers";
export {normalizeHrefPath} from "./normalize-href-path";

// Type exports
export type {QueryParams, RouteWithQuery, RouteWithSlug, RouteWithSlugAndQuery, SimpleRoute} from "./types";

// Draft preview query (`?draft=true`) — URL + Content API
export {DRAFT_PREVIEW_QUERY_KEY, DRAFT_PREVIEW_QUERY_VALUE} from "./constants/draft-preview-query";
